import { map } from 'lodash';

let landingInit;
const entitlementsEndpoint = '/ajax/entitlements';

(function ($) {

  var getIds = function (hits) {
    return map(hits, 'nid');
  };

  landingInit = function (pillar) {
    var rentals = [];
    var id = 0;

    // Collect all rental IDs
    $.each($('[data-search="rentals-text-label"]'), function () {
      id = $(this).data('filmId');
      rentals.push({ 'nid': id });
    });

    if (rentals.length) {
      // Make AJAX request to get entitlement data
      $.ajax(entitlementsEndpoint, {
        method: 'GET',
        contentType: "application/json",
        data: {
          ids: getIds(rentals).join('|'),
          pillar: pillar, // use dynamic pillar
          type: 'labels'
        }
      }).done(function (data) {
        //console.log(data);

        // Loop over the entitlement data and update the UI
        $.each(data, function (id, message) {
          var $targetElement = $('[data-search="rentals-text-label"][data-film-id="' + id + '"]');
          // If the entitlement message is not empty, update the element
          if (!$.isEmptyObject(message)) {
            if (typeof message['card_expiry'] !== 'undefined') {
              $targetElement
                .attr('data-ent', 'yes')
                .html(message['card_expiry'])
                .closest('.film_card--label').removeClass('d-n')
                .css({ 'background-color': '#FF5555' });
            }
          }
        });
      });
    }
  };

})(jQuery);

const fetchEntitlementCta = async function (filmId, pillar) {
  try {
    const response = await fetch(`${entitlementsEndpoint}?ids=${filmId}&pillar=${pillar}&type=cta`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching entitlement CTA:', error);
    throw error;
  }
};

export default {
  landingInit,
  fetchEntitlementCta,
};
